import React from 'react';
interface ProjectFilterProps {
  categories: string[];
  activeCategory: string;
  onSelectCategory: (category: string) => void;
}
export function ProjectFilter({
  categories,
  activeCategory,
  onSelectCategory
}: ProjectFilterProps) {
  return <div className="flex flex-wrap gap-4 mb-12" data-id="element-84">
      {categories.map(category => <button key={category} onClick={() => onSelectCategory(category)} className={`px-6 py-2 text-sm font-bold uppercase tracking-wider transition-all duration-300 border ${activeCategory === category ? 'bg-yellow-400 text-black border-yellow-400' : 'bg-transparent text-gray-400 border-white/10 hover:border-yellow-400 hover:text-yellow-400'}`} data-id="element-85">
          {category}
        </button>)}
    </div>;
}